// Assembled UI message catalog. Each section is its own file so the migration
// can grow by ADDING a section import here (no central-file merge conflicts).
// `MessageKey` is the union of every section's keys — `t()` is fully typed.

import { access } from "./access.js";
import { account } from "./account.js";
import { admin } from "./admin.js";
import { analytics } from "./analytics.js";
import { breakdown } from "./breakdown.js";
import { chatRender } from "./chatRender.js";
import { chatTop } from "./chatTop.js";
import { common } from "./common.js";
import { dashboard } from "./dashboard.js";
import { errors } from "./errors.js";
import { fields } from "./fields.js";
import { legal } from "./legal.js";
import { meetings } from "./meetings.js";
import { focus } from "./focus.js";
import { panel } from "./panel.js";
import { plurals } from "./plurals.js";
import { projects } from "./projects.js";
import { readiness } from "./readiness.js";
import { theme } from "./theme.js";
import type { MsgSection, PluralSection } from "./types.js";

const SECTIONS = [
  common,
  fields,
  focus,
  readiness,
  breakdown,
  chatRender,
  chatTop,
  dashboard,
  projects,
  analytics,
  access,
  account,
  admin,
  theme,
  errors,
  legal,
  meetings,
  panel,
] as const;

export const MESSAGES = Object.assign({}, ...SECTIONS) as Record<string, MsgSection[string]>;
export type MessageKey = keyof typeof MESSAGES & string;

export const PLURALS = plurals as PluralSection;
export type PluralKey = keyof typeof plurals & string;
